import { connect } from "react-redux";
import {
  requestAdminAmcs,
  requestAdminFunds,
  requestAdminFundsSuccess,
  requestAdminCreateGenericLink,
  requestLandingPages
} from "src/redux/actions";
import CreateGenericLink from "./create-generic-link";

const mapStateToProps = (state) => ({
  adminAmcs: state.adminAmcs,
  adminFunds: state.adminFunds,
  landingPages: state.landingPages,
  defaultEuin: state.adminCredentials?.adminUser?.defaultEuin,
  defaultArnNumber: state.adminCredentials?.adminUser?.defaultArnNumber,
  defaultEmployeeCode: state.adminCredentials?.adminUser?.employeeCode,
});

export default connect(mapStateToProps, {
  requestAdminAmcs,
  requestAdminFunds,
  requestAdminFundsSuccess,
  requestAdminCreateGenericLink,
  requestLandingPages
})(CreateGenericLink);
